import React, { Component } from "react";
import {
  CardTitle,
  Card,
  CardHeader,
  ButtonGroup,
  Button,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { StoreService } from "../../services/storeService";
import { Link } from "react-router-dom";
import {reloadPlaylist, reloadStores} from "../../redux/actions/index";
import { connect } from "react-redux";
import { Search } from "../../containers";
import { CompanyService } from "../../services/companyService";
import { ModalDelete } from "../../containers";
import SearchInput, { createFilter } from "react-search-input";
import PropTypes from "prop-types";
import { ChannelService } from "../../services/channelService";
import { BrandService } from "../../services/brandService";
import { ZoneService } from "../../services/zoneService";
import { PlaylistService } from "../../services/playlistService";

import moment from "moment";
const KEYS_TO_FILTERS = ["name", "brandName", "zoneName", "computerId", "manager", "telephone", "email", "songName", "ip", "isConnected"];

let storeService = new StoreService();
let companyService = new CompanyService();
let channelService = new ChannelService();
let brandService = new BrandService();
let zoneService = new ZoneService();
let playlistService = new PlaylistService();

class TableHead extends Component {
  render() {

    return (
      <thead>
        <tr>
          <th onClick={()=> this.props.orderColumn('name')}><i className="fa fa-sort"><b>Tienda</b></i></th>
          <th onClick={()=> this.props.orderColumn('brandId')}><i className="fa fa-sort"><b>Marca</b></i></th>
          {this.props.viewButton && <th onClick={()=> this.props.orderColumn('companyId')}><i className="fa fa-sort"><b>Cliente</b></i></th>}
          <th onClick={()=> this.props.orderColumn('zoneId')}><i className="fa fa-sort"><b>zona</b></i></th>
          <th onClick={()=> this.props.orderColumn('computerId')}><i className="fa fa-sort"><b>Dispositivo</b></i></th>
          {this.props.viewButton && (
            <React.Fragment>
              <th onClick={()=> this.props.orderColumn('manager')}><i className="fa fa-sort"><b>Contacto</b></i></th>
              <th onClick={()=> this.props.orderColumn('telephone')}><i className="fa fa-sort"><b>Teléfono</b></i></th>
              <th onClick={()=> this.props.orderColumn('email')}><i className="fa fa-sort"><b>Email</b></i></th>
            </React.Fragment>
          )}
          <th onClick={()=> this.props.orderColumn('songName')}><i className="fa fa-sort"><b>Última canción</b></i></th>
          <th onClick={()=> this.props.orderColumn('computerTime')}><i className="fa fa-sort"><b>Tiempo del dispositivo</b></i></th>
          <th onClick={()=> this.props.orderColumn('lastConnection')}><i className="fa fa-sort"><b>Última conexión</b></i></th>
          <th onClick={()=> this.props.orderColumn('ip')}><i className="fa fa-sort"><b>IP</b></i></th>
          <th onClick={()=> this.props.orderColumn('volumen')}><i className="fa fa-sort"><b>Volumen</b></i></th>
          <th>Estado</th>
          <th onClick={()=> this.props.orderColumn('playlistMusicId')}><i className="fa fa-sort"><b>Playlist</b></i></th>
          <th>Acción</th>
        </tr>
      </thead>
    );
  }
}


const MINUTE = 60 * 1000;
const TEN_MINUTES = MINUTE * 10
const HOUR = MINUTE * 60;

class Connection extends Component {

  render() {
    let lastConnection = this.props.lastConnection;
    if (lastConnection) {
      let date = new Date();
      let connectionDate = new Date(lastConnection);
      //console.log(date - connectionDate);
      let dif = date - connectionDate;
      if (dif < TEN_MINUTES) return <td className="text-success">Conectado</td>;
      else if (dif > HOUR)
        return <td className="text-danger">Desconectado</td>;
      return <td className="text-warning">Conectado</td>;
    }
    return <td className="text-danger">-</td>;
  }
}

class Store extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false
    };
    this.toogleDelete = this.toogleDelete.bind(this);
    this.sendDelete = this.sendDelete.bind(this);
  }
  toogleDelete() {
    this.setState({
      deleting: !this.state.deleting
    });
  }
  sendDelete() {
    let self = this;
    storeService.deleteById(this.props.item.id).then(function(data) {
      storeService.reload();
      self.context.getNotificationSystem().addNotification({
        message:
          "Se ha eliminado exitosamente la Tienda: " +
          self.props.item.name +
          ".",
        title: "Tienda Eliminada",
        level: "success"
      });
      self.toogleDelete();
    });

  }

  render() {
    let deleting = this.state.deleting;
    let item = this.props.item;
    let plMusic;
    let plSpot;

    //TODO: process playlist sequence
    if(item.playlistMusicId !== null){
      plMusic = item.plMusic;
    }else if (item.zone !== undefined  && item.zone !== null && item.zone.plMusic !== undefined && item.zone.plMusic !== null){
      plMusic = item.zone.plMusic
    }else if(item.brand !== undefined && item.brand !== null && item.brand.plMusic !== undefined && item.brand.plMusic !== null){
      plMusic = item.brand.plMusic
    }


    if(item.playlistSpotId !== null){
      plSpot = item.plSpot;
    }else if (item.zone !== undefined  && item.zone.plSpot !== null  && item.zone.plSpot !== undefined && item.zone.plSpot !== null){
      plSpot = item.zone.plSpot
    }else if(item.brand !== undefined   && item.brand !== null  && item.brand.plSpot !== undefined && item.brand.plSpot !== null){
      plSpot = item.brand.plSpot
    }

    return (
      <tr>
        <td >{item.name}</td>
        <td>{brandService.MatchName(item.brandId)}</td>
        {this.props.viewButton && (
          <td>{companyService.MatchName(item.companyId)}</td>
        )}
        <td>{zoneService.MatchName(item.zoneId)}</td>
        <td>{item.computerId}</td>
        {this.props.viewButton && (
          <React.Fragment>
            <td>{item.manager}</td>
            <td>{item.telephone}</td>
            <td>{item.email}</td>
          </React.Fragment>
        )}
        <td>
          {item.songName ? item.songName : "No ha tocado ninguna canción"}
        </td>
        <td>
          {item.computerTime
            ? moment(item.computerTime).format("DD/MM/YYYY HH:mm")
            : "-"}
        </td>
        <td>
          {item.lastConnection
            ? moment(item.lastConnection).format("DD/MM/YYYY HH:mm")
            : "Nunca se ha Conectado"}
        </td>
        <td>
          {item.ip}
        </td>
        <td>
          {item.volumen ? ((typeof item.volumen === 'string')? ((item.volumen[0] === '1')? 100 : item.volumen.slice(2,4)):Number(item.volumen) <= 1 ? Math.trunc(item.volumen*100):item.volumen) : 0} %
        </td>

        <Connection lastConnection={item.lastConnection} />
        <td>
          Música: {playlistService.MatchName(plMusic)} <br/>
          Publicidad: {playlistService.MatchName(plSpot)}
        </td>
        <td className="text-center">
          <ButtonGroup className="mr-3" aria-label="First group">
            {this.props.viewButton && (
              <Button
                onClick={this.toogleDelete}
                className="btn btn-danger btn-sm"
              >
                <i className="fa fa-trash" />
                {deleting && (
                  <ModalDelete
                    show={deleting}
                    close={this.toogleDelete}
                    sendDelete={this.sendDelete}
                    name={item.name}
                    entityName="una Tienda"
                  />
                )}
              </Button>
            )}

            <Link
              to={"/stores/view/" + item.id}
              className="btn btn-primary btn-sm"
            >
              <i className="fa fa-eye" />
            </Link>
          </ButtonGroup>
        </td>
      </tr>
    );
  }
}

Store.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

class StoreConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      searchTerm: ""
    };
    channelService.reload();
    companyService.reload();
    brandService.reload();
    zoneService.reload();
    playlistService.reload();
    this.mounted = true;
    this.loadData(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }
  componentWillUnmount() {
    this.mounted = false;
  }
  searchUpdated(term) {
    this.setState({ searchTerm: term });
  }
  handleChange(event) {
    if(event.target.id === 'company'){
      this.setState({['brand']: undefined});
    }
    this.setState({ [event.target.id]: event.target.value });
  }
  isConnected(lastConnection) {
    if (lastConnection) {
      let date = new Date();
      let connectionDate = new Date(lastConnection);

      let dif = date - connectionDate;
      if (dif < TEN_MINUTES) return "Conectado";
      else if (dif > HOUR)
        return "Desconectado";
      return "Conectado";
    }
    return "-";
  }
  loadData(self) {
    storeService
      .read()
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.props.reloadStores(data);
        }
        if (self.mounted)
          self.setState({
            loading: false
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  render() {
    let data = this.props.data;
    let user = this.props.user.user
    let company = user.companyId;
    let brand = user.brandId;

    if(user.role !== "ADMIN") {
      company = user.companyId;
    } else {
      company = this.state.company;
    }
    if(user.role !== "ADMIN") {
      brand = user.brandId;
    } else {
      brand = this.state.brand;
    }
    let filtered = data;
    if (company) {
      filtered = filtered.filter(x => company === x.companyId);
    }
    if (brand) {
      filtered = filtered.filter(x => brand === x.brandId);
    }
    // add brandId and zoneId to items for search
    if(this.state.searchTerm){
      for (let i = 0; i < filtered.length; i++) {
        if(filtered[i].brand != undefined) filtered[i].brandName = filtered[i].brand.name;
        if(filtered[i].zone != undefined) filtered[i].zoneName = filtered[i].zone.name;
      }
    }

    filtered = filtered.filter(
      createFilter(this.state.searchTerm, KEYS_TO_FILTERS)
    );


    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <div className="d-sm-flex w-100 justify-content-between">
              <CardTitle className="mb-0">Tiendas</CardTitle>
              {user.role === "ADMIN" &&
              (
                <h6 className="mb-1">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>Compañia</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      id="company"
                      value={company}
                      onChange={this.handleChange}
                    >
                      <option value="">Cualquier Compañia</option>
                      {this.props.companies.map((e, i) => {
                        return (
                          <option key={i} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </Input>
                  </InputGroup>
                </h6>
              )}
              {user.role === "ADMIN" &&
              (
                <h6 className="mb-1">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>Marca</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      id="brand"
                      value={brand}
                      onChange={this.handleChange}
                    >
                      <option value="">Cualquier Marca</option>
                      {this.props.brands
                        .filter(x => x.companyId === company || company === "")
                        .map((e, i) => {
                          return (
                            <option key={i} value={e.id}>
                              {e.name}
                            </option>
                          );
                        })}
                    </Input>
                  </InputGroup>
                </h6>
              )}
              <h6 className="mb-1 col-sm-5">
                <SearchInput
                  className="search-input input-group"
                  inputClassName="form-control"
                  placeholder="Buscar..."
                  onChange={this.searchUpdated}
                />
              </h6>
            </div>
          </CardHeader>
          <Search
            table={true}
            Thead={TableHead}
            data={filtered}
            ObjectTemplate={Store}
            loading={this.state.loading}
            bordered={false}
            striped={false}
            viewButton={user.role === "ADMIN"}
            companies={this.props.companies}
            brands={this.props.brands}
            channels={this.props.channels}
            playlists={this.props.playlists}
            zones={this.props.zones}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.stores,
    companies: state.companies,
    user: state.user,
    channels: state.channels,
    zones: state.zones,
    playlists: state.playlists,
    brands: state.brands
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadStores: stores => dispatch(reloadStores(stores)),
    reloadPlaylist: playlists => dispatch(reloadPlaylist(playlists))
  };
};

const Stores = connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreConnector);

export default Stores;
